import { createContext } from 'react'

export const EditModeContext = createContext(false)